import DataHandlerService from "@/services/data";
import ContentService from "@/services/content";
import FileUtils from "@/utils/file";
import RandomValues from "@/utils/random";
import AddToMap from "../AddToMap/AddToMap.vue"

const data = new DataHandlerService();
const contentService = new ContentService();
const fileUtils = new FileUtils();
const randomValues = new RandomValues();
import { VueEditor } from "vue2-editor";

import { toolbarOptions } from '@/constants/editortoolbar.js';

export default {
  name: "new-topic",
  props: ["circle_id", "circleState", "CIRCLE_STATES"],
  components: { AddToMap, VueEditor },
  data() {
    return {
      user: data.getUserData(),
      title: "",
      titleRef: {
        dirty: false,
        invalid: true
      },
      body: "",
      bodyRef: {
        dirty: false,
        invalid: true
      },
      STATES: ["DEFAULT", "PROCESSING"],
      state: "",
      images: [],
      coordinates: null,
      toolbarOptions: toolbarOptions
    };
  },
  created() {
    this.setState(this.STATES[0]);
  },
  computed: {
    formIsValid: function() {
      return !this.titleRef.invalid && !this.bodyRef.invalid;
    }
  },
  watch: {
    title: function(val) {
      this.titleRef.dirty = true;
      if (val === "") {
        this.titleRef.invalid = true;
      } else {
        this.titleRef.invalid = false;
      }
    },
    body: function(val) {
      this.bodyRef.dirty = true;
      if (val === "") {
        this.bodyRef.invalid = true;
      } else {
        this.bodyRef.invalid = false;
      }
    }
  },
  methods: {
    resetForm() {
      this.title = "";
      this.body = "";

      this.titleRef = {
        dirty: false,
        invalid: true
      };
      this.bodyRef = {
        dirty: false,
        invalid: true
      };
    },
    setState(state) {
      this.state = state;
    },
    spawnStateChangeInCirclePage(emittedState) {
      this.$emit("stateChangeFromNewTopic", emittedState);
      this.resetForm();
    },
    submit() {
      const form = {
        circle_id: this.$props.circle_id,
        title: this.title,
        body: this.body,
        profile_id: this.user._id
      };

      this.setState(this.STATES[1]);
      document.getElementById("btn--submit").innerHTML = "Posting";

      if (this.images.length > 0) {
        contentService.createTopicWithImages(form, this.images, this.coordinates).then((res) => {
          if(res) {
            this.$root.$emit("SaveNewTopic", res);
          }
          this.spawnStateChangeInCirclePage(this.$props.CIRCLE_STATES[2]);
          this.$notification.new("Topic created");
        }).catch(response => {
          this.setState(this.STATES[0]);
          document.getElementById("btn--submit").innerHTML = "Post";
          this.$root.$emit("ShowErrorNotification", response.message);
        });
      } else {
        contentService.createTopic(form, this.coordinates).then((res) => {
          if(res && res.topic && res.post) {
            this.$root.$emit("SaveNewTopic", res);
          }
          this.spawnStateChangeInCirclePage(this.$props.CIRCLE_STATES[2]);
          this.$notification.new("Topic created");
        }).catch(response => {
          this.setState(this.STATES[0]);
          document.getElementById("btn--submit").innerHTML = "Post";
          this.$root.$emit("ShowErrorNotification", response.message);
        });
      }
    },
    selectImageFromFS() {
      if (this.images.length !== 4) {
        const hiddenImageInput = document.getElementById("image-input");
        hiddenImageInput.click();
      }
    },
    async imageSelectCallback(e) {
      const files = e.target.files || e.dataTransfer.files;
      const validationStatus = fileUtils.validateFile(files);
      if (validationStatus.valid) {
        this.images.push({
          id: randomValues.secureRandString(),
          file: files[0],
          src: await fileUtils.getSrc(files)
        });
      } else {
        this.$root.$emit("ShowErrorNotification", validationStatus.message);
      }
    },
    removeImage(imageId) {
      this.images.splice(this.images.findIndex(s => s.id === imageId), 1);
    },
    hideUploadSection() {
      const uploadGroup = document.getElementById('upload-group');
      const uploadBtn = document.getElementById('upload-btn');

      if (uploadGroup.hidden) {
        uploadGroup.hidden = false;
        uploadBtn.classList.remove("btn-light");
        uploadBtn.classList.add("btn-danger");
        uploadBtn.innerHTML = "<ion-icon name='ios-close'></ion-icon> Remove Photos";
      } else {
        uploadGroup.hidden = true;
        uploadBtn.classList.add("btn-light");
        uploadBtn.classList.remove("btn-danger");
        uploadBtn.innerHTML = "<ion-icon name='ios-images'></ion-icon> Upload Photos";
        this.images = [];
      }
    },
    setCoordinates(coordinates) {
      this.coordinates = coordinates;
    },
    onEditorBlur(quill) {
      // console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      // console.log("editor focus!", quill);
    },
    onSelectionChange(range) {
      // console.log("selection change!", range);
    }
  }
};
